export default [{
  path: '/variacoes-preco-unitario',
  component: () => import('@/views/Index'),
  children: [
    {
      name: 'Variações de Preço Unitário Histórico',
      path: 'historico',
      component: () => import('@/views/variacoesPrecoUnitario/Historico.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups'},
          { name: 'Variações de Preço Unitário' }
        ]
      }
    },
    {
      name: 'Variações de Preço Unitário Adicionar',
      path: 'edit',
      component: () => import('@/views/variacoesPrecoUnitario/Edit.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups'},
          { name: 'Variações de Preço Unitário', path: '/variacoes-preco-unitario/historico' },
          { name: 'Adicionar' }
        ]
      }
    },
    {
      name: 'Variações de Preço Unitário Editar',
      path: 'edit/:id',
      component: () => import('@/views/variacoesPrecoUnitario/Edit.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups'},
          { name: 'Variações de Preço Unitário', path: '/variacoes-preco-unitario/historico' },
          { name: 'Editar' }
        ]
      }
    },
    {
      name: 'Variações de Preço Unitário Visualizar',
      path: 'visualizar/:id',
      component: () => import('@/views/variacoesPrecoUnitario/Visualizar.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups'},
          { name: 'Variações de Preço Unitário', path: '/variacoes-preco-unitario/historico' },
          { name: 'Visualizar' }
        ]
      }
    }
  ]
}]